// components/RatingStars.tsx
import React from "react";
import { Star } from "@mui/icons-material";

interface RatingStarsProps {
  rating: number; // تقييم المنتج
  layoutVariant?: "extra-small" | "small" | "medium" | "large";
}

const RatingStars: React.FC<RatingStarsProps> = ({ rating, layoutVariant = "large" }) => {
  if (!rating || layoutVariant === "extra-small") return null;

  const starSize = layoutVariant === "small" ? "w-3 h-3" : "w-4 h-4";

  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className={`${starSize} ${i < Math.floor(rating) ? "text-yellow-400" : "text-gray-300"}`}
        />
      ))}
      {layoutVariant !== "small" && (
        <span className="text-xs text-gray-500 ml-1">
          ({rating.toFixed(1)})
        </span>
      )}
    </div>
  );
};

export default RatingStars;
